<template>
  <div class="calendar_main" :class="{'cn':version == '1','ja':version == '2'}">
    <div class="calendar_left">
      <div class="calendar_box">
        <div class="calendar_top">
          <div class="text span1">{{calendarDateStr}}</div>
          <div class="btn_box">
            <div class="tetx btn1" @click="lastYear()">{{$t('App.calendar.text2')}}</div>
            <div class="tetx btn2" @click="lastMonth()">{{$t('App.calendar.text3')}}</div>
            <div class="tetx btn3" @click="nextMonth()">{{$t('App.calendar.text4')}}</div>
            <div class="tetx btn4" @click="nextYear()">{{$t('App.calendar.text5')}}</div>
          </div>
        </div>
        <div class="calendar_cont">
          <div class="li li1">
            <div class="div">{{$t('App.calendar.calendar_text2')}}</div>
            <div class="div">{{$t('App.calendar.calendar_text3')}}</div>
            <div class="div">{{$t('App.calendar.calendar_text4')}}</div>
            <div class="div">{{$t('App.calendar.calendar_text5')}}</div>
            <div class="div">{{$t('App.calendar.calendar_text6')}}</div>
            <div class="div">{{$t('App.calendar.calendar_text7')}}</div>
            <div class="div">{{$t('App.calendar.calendar_text1')}}</div>
          </div>
          <div class="li" v-for="(item,index) in calendarList" :key="index+'li1'">
            <div v-for="(obj,i) in item" :key="i+'li2'" class="div" :class="{'noOne':obj.type=='-1'||obj.type=='1','select':obj.type=='3','number':obj.number>0}" @click="calendarClick(obj)">
              {{obj.val}}
              <template v-if="obj.number>0">
                <div class="i_box">
                  <div class="i" v-for="d in obj.number" :key="d+'_i'"></div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="calendar_right">
      <div class="p_box">
        <div class="p" v-for="(item,index) in scheduleDetailsList" :key="index" >
          <div v-if="item.timeType == 0" @click="editSchedule(item,index)">
            <p class="p1">
              <span class="span1" v-if="item.days">
                {{item.startDate+'-'+item.endDate+' '+item.dayStr}}
              </span>
              <span class="span1" v-if="!item.days">
                {{item.startDate+'-'+item.endDate}}
              </span>
            </p>
            <p class="p2">
              <span class="span2">{{item.startTime+'-'+item.endTime+' '+$t('App.calendar.text1') +' '+ item.sceneName}}</span>
            </p>
            <el-button type="text" icon="el-icon-delete"  @click.stop="delSchedule(item,index)"></el-button>
          </div>
          <div v-if="item.timeType == 1" @click="editSchedule(item,index)">
            <p class="p1">
              <span class="span1" v-if="item.days">
                {{item.startDate+'-'+item.endDate+' '+item.dayStr}}
              </span>
              <span class="span1" v-if="!item.days">
                {{item.startDate+'-'+item.endDate}}
              </span>
            </p>
            <p class="p2">
              <span class="span2">{{item.type1_str+' '+$t('App.calendar.text1') +' '+ item.sceneName}}</span>
            </p>
            <el-button type="text" icon="el-icon-delete"  @click.stop="delSchedule(item,index)"></el-button>
          </div>
        </div>
        <!-- <div class="p">2020.02.0418:00-19:30 Football Practice</div>
        <div class="p">2020.02.04 20:00-21:00 Football Practice</div> -->
      </div>
      <!-- <div class="icon btn" @click="pageTypeFun('schedule')"></div> -->
      <div class="flex_box">
        <!-- <div class="el-icon-circle-plus-outline" @click="pageTypeFun('sceneSettingEdit')"></div> -->
        <div class="button" @click="pageTypeFun('schedule')">{{$t('App.calendar.text6')}}</div>
      </div>
    </div>
    
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'
import allUrl from '../api/allUrl.js'
import base from '../api/base.js'
export default {
  name: 'calendar',
  data () {
    return {
      isShowprojectCompleted: false,
      calendarList: [],
      calendarDate: null,
      calendarDateHc: null,
      mapCurvePanelDate: {
        dd1: '',
        hh1: '0',
        mm1: '0',
        dd2: '',
        hh2: '0',
        mm2: '0',
      },
      monthArr: [],
      calendarDateStr: '',

      scheduleDetailsList:[],
      weekArr:[],

      scheduleList:'',
    }
  },
  computed: {
    ...mapGetters({
      token: 'token',
      client_key: 'client_key',
      username: 'username',
      version: 'version',

      projectId: 'projectId',

      timezoneId:'timezoneId',
      
      remRatio: 'remRatio',
      updateRemRatio: 'updateRemRatio',
      scheduleTime: 'scheduleTime',
      countryId: 'countryId',
      provinceId: 'provinceId',
      cityId: 'cityId',
      hotelId: 'hotelId',
      headerIdStr: 'headerIdStr',
      themeType: 'themeType',
    }),
    // sensorFormModelName(){
    //     let name = '';
    //     for(let d of this.modelNav){
    //         if(d.id == this.sensorForm.model){
    //             name = d.name
    //         }
    //     }
    //     return name
    // }
  },
  components: {
    // 'sideBar':sideBar
  },
  beforeDestroy () {
  },
  mounted () {
    
    this.weekArr = [this.$t('App.calendar.calendar_text1'),this.$t('App.calendar.calendar_text2'),this.$t('App.calendar.calendar_text3'),this.$t('App.calendar.calendar_text4'),this.$t('App.calendar.calendar_text5'),this.$t('App.calendar.calendar_text6'),this.$t('App.calendar.calendar_text7')]
    this.monthArr = [this.$t('App.calendar.month1'), this.$t('App.calendar.month2'), this.$t('App.calendar.month3'),
    this.$t('App.calendar.month4'), this.$t('App.calendar.month5'), this.$t('App.calendar.month6'),
    this.$t('App.calendar.month7'), this.$t('App.calendar.month8'), this.$t('App.calendar.month9'), this.$t('App.calendar.month10'), this.$t('App.calendar.month11'), this.$t('App.calendar.month12')]
    

    if(this.scheduleTime == ''){
      this.setCalendarList(new Date())
    } else{
      console.log(this.scheduleTime,'----5656---')
      this.setCalendarList(new Date(this.scheduleTime))
    }

    // this.setCalendarList(new Date())

    // if(this.projectId){
    //   // console.log(this.calendarDate)
    //   this.scheduleListGet(new Date())
    // }
  },
  methods: {
    skinClassFun(){
      let obj = {};
      obj['cn'] = this.version == '1';
      // obj['ratio_1920_1080'] = this.ratio == '1';
      if(this.themeType == 1){
        obj['themeType_' + 1] = true;
      }
      // obj['themeType_' + 1] = true;
      return obj
    },
    pageTypeFun(val) {
      this.$emit('pageTypeFun',val)
      this.$store.commit("scheduleTypeFun", {
        scheduleData: '',
        scheduleType: "add",
      });
      
      this.$store.commit("timezoneSelectFun", {
        timezoneId: '',
        // projectName: data.name,
      });
    },
    editSchedule(data,index){ 
      console.log(data,index)
      console.log(data,'-95999599595')
      data.sceneId = data.sceneId + '';
      this.$emit('pageTypeFun','schedule')

      this.$store.commit("timezoneSelectFun", {
        timezoneId: data.id,
        // projectName: data.name,
      });

      // console.log(this.timezoneId,'-11-111-1-1555545554')
      this.$store.commit("scheduleTypeFun", {
        scheduleData: data,
        scheduleType: "edit",
      });
    },
    delSchedule(item,index){
      this.$confirm(
        this.$t('App.message.text3'), this.$t('App.message.text4'), {
        confirmButtonText: this.$t('App.message.text5'),
        cancelButtonText: this.$t('App.message.text6'),
        type: 'warning'
      }
      ).then(() => {
        console.log(item.id)
        base.ajax_post(
          allUrl.schedule.schedule_del,
          {
            username: this.username,
            clientType: this.os,
            token: this.token,
            id:item.id
          },
          {},
          data => {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'success'
            });
            // this.sceneListGet();
            this.scheduleDetailsList.splice(index, 1);
            this.setCalendarList(this.calendarDateHc)
          },
        this)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('App.message.text7')
        })
      });
    },
    calendarClick(data){
      // console.log(data,'--111111111122222222')
      for(let d of data.eventList){
        if(d.days){
          let arr = d.days.split(',');
          let dayStr = '';
          for(let dd of arr){
            if(dayStr==''){
              dayStr = this.weekArr[dd]
            }else{
              dayStr = dayStr+','+this.weekArr[dd]
            }
          }
          this.$set(d,'dayStr',dayStr)
        }

        // this.timezoneId = d.id;
      }
      this.scheduleDetailsList = data.eventList;

      // console.log(this.scheduleDetailsList,'-5555555555555555555')
    },
    lastYear () {
      let month = this.calendarDateHc.getMonth();
      let year = this.calendarDateHc.getFullYear();
      if (month == 0) {
        month = 12
        year = year - 1;
      }
      month = month + 1;
      year = year - 1;
      this.setCalendarList(new Date(year + '-' + month + '-' + this.calendarDateHc.getDate()));
    },
    lastMonth () {
      let month = this.calendarDateHc.getMonth();
      let year = this.calendarDateHc.getFullYear();
      if (month == 0) {
        month = 12
        year = year - 1;
      }
      this.setCalendarList(new Date(year + '-' + month + '-' + this.calendarDateHc.getDate()));
    },
    nextMonth () {
      let month = this.calendarDateHc.getMonth() + 2;
      let year = this.calendarDateHc.getFullYear();
      if (month > 12) {
        month = 1;
        year = year + 1;
      }
      this.setCalendarList(new Date(year + '-' + month + '-' + this.calendarDateHc.getDate()));
    },
    nextYear () {
      let month = this.calendarDateHc.getMonth();
      let year = this.calendarDateHc.getFullYear();
      month = month + 1;
      year = year + 1;
      this.setCalendarList(new Date(year + '-' + month + '-' + this.calendarDateHc.getDate()));
    },
    setCalendarList (date) {
      // console.log(date)
      this.calendarDateHc = date;
      // let this_ = this;
      this.calendarList = [];
      //判断是否为闰年
      function is_leap (year) {
        //闰年的条件是符合下面二者之一：
        //(1)年份能被4整除，但不能被100整除；
        //(2)年份能被400整除。
        if ((year % 4 == 0 && year % 100 != 0) || (year % 400 == 0)) {
          return 1;
        }
        return 0;
      }
      let days_of_month = new Array(31, 28 + is_leap(fullYear), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
      let fullYear = date.getFullYear(); //获取年份
      let month = date.getMonth(); //获取月份，返回值是0(一月)到11(十二月)之间的一个整数。
      let week = new Date(fullYear + '-' + (month + 1) + '-' + 1).getDay();
      console.log(new Date(fullYear + '-' + (month + 1) + '-' + 1), week)
      // console.log(this.version)
      if (this.version == 1) {
        this.calendarDateStr = fullYear + '年' + this.monthArr[month];
        this.calendarDate = fullYear + '年' + (month) + '月';
      } else {
        this.calendarDateStr = this.monthArr[month] + ' ' + fullYear;
        this.calendarDate = fullYear + '年' + (month) + '月';
      }
      // let week = new Date().getDay();
      // let dd;
      // if (this.mapCurvePanelDate.dd1) {
      //   dd = new Date(this.mapCurvePanelDate.dd1).getDate()
      // }
      // if (this.calendarShwo == '1') {
      //   if (this.mapCurvePanelDate.dd1) {
      //     dd = new Date(this.mapCurvePanelDate.dd1).getDate()
      //   }
      // }
      // if (this.calendarShwo == '2') {
      //   if (this.mapCurvePanelDate.dd2) {
      //     dd = new Date(this.mapCurvePanelDate.dd2).getDate()
      //   }
      // }
      // let rows = Math.ceil((days_of_month[month] + (week == 0?7:week)) / 7);
      let rows = 6;
      // console.log(month, '-------', week,days_of_month[month] + (week == 0?7:week),rows)
      // console.log(rows)
      for (let i = 0; i < rows; i++) { //外层for语句 - tr标签
        let list = [];
        for (let k = 0; k < 7; k++) { //内层for语句 - td标签
          let idx = i * 7 + k; //表格单元的自然序号
          let date_str = idx - (week == 0 ? 7 : week) + 2; //计算日期
          // console.log(idx,date_str)
          let number = 0;
          // if (date_str == '5' || date_str == '13') {
          //   number = 3
          // }
          if (date_str <= 0) {
            list.push({ val: days_of_month[month == 0 ? 11 : month - 1] + date_str, type: '-1' });
            // console.log(date_str,i,k,days_of_month[month-1]-date_str)
          }
          if (date_str > 0 && date_str <= days_of_month[month]) {
            // if (isTrue && dd == date_str) {
            //   list.push({ val: date_str, type: '3',number:number });
            // } else {
            list.push({ val: date_str, type: '0', number: number });
            // }
            // console.log(date_str, i, k)
          }
          if (date_str > days_of_month[month]) {
            list.push({ val: date_str - days_of_month[month], type: '1' });
          }
          //这里是处理有效日期代码
        }
        this.calendarList.push(list)
      } //外层for语句结束
      
      if(this.projectId){
        this.scheduleListGet(date)
      }
      // console.log(this_.calendarList)
    },
    // linkToFun(val,data){
    // }
    
    scheduleListGet(obj) {
      let month = obj.getMonth()+1;
      let year = obj.getFullYear();
      base.ajax_post(
        allUrl.schedule.schedule_getCalender,
        {
          username: this.username,
          version: this.version,
          token:this.token,
          projectId:this.projectId,
          date:year+'-'+month
        },
        {},
        data => {
          console.log(data)
          for(let d of data.data){
            if(d.eventCount>0){
              for(let arr of this.calendarList){
                for(let dd of arr){
                  // console.log(d,dd)
                  if(d.day==dd.val&&dd.type=='0'){
                    // dd.number = d.eventCount
                    for(let ddd of d.eventList){
                      if(ddd.timeType == 1){
                        let str1 = ddd.sunriseOffsetTime>0?this.$t('App.calendar.text7'):this.$t('App.calendar.text8');
                        let str2 = ddd.sunsetOffsetTime>0?this.$t('App.calendar.text9'):this.$t('App.calendar.text10');
                        let str3 = ddd.sunriseTimeUnit==0?this.$t('App.schedule.timeUnit0'):this.$t('App.schedule.timeUnit1');
                        let str4 = ddd.sunsetTimeUnit==0?this.$t('App.schedule.timeUnit0'):this.$t('App.schedule.timeUnit1');
                        ddd.type1_str = str1 + Math.floor(ddd.sunriseOffsetTime) + str3 + '-'+ str2 + Math.floor(ddd.sunriseOffsetTime) + str4

                      }
                    }
                    this.$set(dd,'number',d.eventCount)
                    this.$set(dd,'eventList',d.eventList)
                  }
                }
              }
            }
          }
          // this.scheduleList = data.data;
          // 
          // console.log(this.gatewayList)
        },
        this
      )
    },
  },
  watch: {
    projectId:function(){
      // this.scheduleListGet();
      this.setCalendarList(new Date())
    }
    // updateRemRatio:function(){
    // }
  }
}
</script>

<style type="text/css" lang="less">
.calendar_main {
  position: absolute;
  top: 5.78rem;
  left: 0;
  width: 100%;
  height: calc(100% - 7rem);
  min-height: 50rem;
  margin: 0 auto;
  overflow: hidden;
  // position: relative;
  display: flex;
  background: rgba(244, 251, 253, 0.85);
  // padding: 4.3rem 7.37rem;
  .calendar_left {
    width: 84.93rem;
    padding: 4rem 4.39rem 0 7.28rem;
  }
  .calendar_right {
    flex: 1;
    padding-top: 4.3rem;
    padding-left: 4.3rem;
    background: rgba(244, 251, 253, 0.8);
    border-left: 0.09rem solid rgba(58, 99, 111, 1);
    .p_box{
      height: calc(100% - 10rem);
    }
    .p {
      font-size: 1.8rem;
      font-family: Calibri;
      font-weight: normal;
      color: #3a636f;
      line-height: 1.8rem;
    }
    .btn{
      margin-left: auto;
      margin-right: 5.46rem;
      cursor: pointer;
      width: 4.28rem;
      height: 4.28rem;
      background-image: url(../img/icon/btn_bg1.png);
      background-position: center;
      background-size: 100% 100%;
    }

    .flex_box {
      display: flex;
      align-items: center;
      justify-content: right;
      margin-right: 5.53rem;
      margin-bottom: 5.46rem;

      .button {
        width: 12.37rem;
        height: 3.16rem;
        line-height: 3.16rem;
        background: #00C6FF;
        border-radius: 0.2rem;
        text-align: center;
        font-family: Calibri;
        font-weight: 400;
        font-size: 1.8rem;
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }
  .calendar_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .span1 {
      font-size: 1.8rem;
      font-family: Calibri;
      font-weight: normal;
      color: #3a636f;
      line-height: 1.8rem;
    }
    .btn_box {
      display: flex;
      .btn1,
      .btn2,
      .btn3,
      .btn4 {
        // width: 5.26rem;
        user-select: none;
        height: 2rem;
        line-height: 2rem;
        text-align: center;
        padding: 0 1rem;
        background: #f4fbfd;
        border: 0.09rem solid #3a636f;
        cursor: pointer;
      }
    }
  }
  .calendar_cont {
    padding: 20px 5px 16px;
    .li {
      display: flex;
      text-align: center;
      height: 9.21rem;
      line-height: 9.21rem;

      background: rgba(244, 251, 253, 0.8);
      .i_box {
        position: absolute;
        bottom: 1.3rem;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 10.35rem;
        .i {
          margin: 0 0.4rem;
          width: 1.05rem;
          height: 1.05rem;
          background: #3a636f;
          border-radius: 50%;
        }
      }
      &:nth-child(1) {
        height: 4.3rem;
        line-height: 4.3rem;
        background: rgba(244, 251, 253, 0);
        .div {
          border: none !important;
          border-bottom: 0.09rem solid rgba(58, 99, 111, 1) !important;
          border-top: 0.18rem solid rgba(58, 99, 111, 1) !important;
          height: 4.3rem;
          line-height: 4.3rem;
        }
      }
      .div {
        // flex: 1;
        // color:rgba(244, 251, 253, 1);
        position: relative;
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
        width: 10.35rem;
        border-bottom: 0.09rem solid rgba(58, 99, 111, 1);
        border-right: 0.09rem solid rgba(58, 99, 111, 1);
        &:nth-child(7n + 1) {
          border-left: 0.09rem solid rgba(58, 99, 111, 1);
        }
        &.noOne {
          // color: rgba(255, 255, 255, 0);
          color: rgba(0, 0, 0, 0.2);
        }
        // &:hover {
        //   color: 000;
        //   background-color: #68a4ff;
        // }
        // &.select {
        //   color: 000;
        //   background-color: #68a4ff;
        // }
        &.number {
          cursor: pointer;
        }
      }
      &:last-child {
        margin-bottom: 0px;
      }
    }
    .li1 {
      .div {
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
        // &:hover {
        //   // color:000;
        //   background-color: #fff;
        // }
      }
    }
  }
}

.ratio_1920_1080 {
  .calendar_main {
    position: absolute;
    top: 5.78rem;
    left: 0;
    width: 100%;
    height: calc(100% - 5.78rem);
    min-height: 50rem;
    margin: 0 auto;
    overflow: hidden;
    // position: relative;
    display: flex;
    background: rgba(244, 251, 253, 0.85);
    // padding: 4.3rem 7.37rem;
    &.ja{
      .calendar_right{
        .flex_box{
          .button{
            width: initial;
            padding: 0 0.5rem;
          }
        }
      }
    }
    .calendar_left {
      width: 95.13rem;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .calendar_box{
        width: 55rem;
      }
      // padding: 3.38rem 19.34rem 0 21.05rem;
    }
    .calendar_right {
      flex: 1;
      padding-top: 4.87rem;
      padding-left: 2.7rem;
      background: rgba(244, 251, 253, 0.8);
      border-left: 0.09rem solid rgba(58, 99, 111, 1);
      .p {
        font-size: 1.37rem;
        // font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
        line-height: 1.8rem;
        cursor: pointer;
        &:hover{
          color: rgba(58,99,11,0.8);
        }
      }
    }
    .calendar_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .span1 {
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3a636f;
        line-height: 1.64rem;
        flex: 1;
      }
      .btn_box {
        width: 33rem;
        // width: 40rem;
        display: flex;
        .btn1,
        .btn2,
        .btn3,
        .btn4 {
          flex: 1;
          // width: 6.58rem;
          user-select: none;
          height: 1.64rem;
          line-height: 1.64rem;
          text-align: center;
          padding: 0;
          background: #f4fbfd;
          border: 0.09rem solid #3a636f;
          cursor: pointer;
          font-size: 1.64rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          white-space:nowrap;
        }
      }
    }
    .calendar_cont {
      padding: 0.66rem 0 0;
      .li {
        display: flex;
        text-align: center;
        height: 7rem;
        line-height: 7rem;

        background: rgba(244, 251, 253, 0.8);
        .i_box {
          position: absolute;
          bottom: 1.3rem;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          .i {
            margin: 0 0.4rem;
            width: 0.79rem;
            height: 0.79rem;
            background: #3a636f;
            border-radius: 50%;
          }
        }
        &:nth-child(1) {
          height: 3.2rem;
          line-height: 3.2rem;
          background: rgba(244, 251, 253, 0);
          .div {
            border: none !important;
            border-bottom: 0.09rem solid rgba(58, 99, 111, 1) !important;
            border-top: 0.18rem solid rgba(58, 99, 111, 1) !important;
            height: 3.2rem;
            line-height: 3.2rem;
          }
        }
        .div {
          // flex: 1;
          // color:rgba(244, 251, 253, 1);
          position: relative;
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          width: 100%;
          border-bottom: 0.09rem solid rgba(58, 99, 111, 1);
          border-right: 0.09rem solid rgba(58, 99, 111, 1);
          &:nth-child(7n + 1) {
            border-left: 0.09rem solid rgba(58, 99, 111, 1);
          }
          &.noOne {
            // color: rgba(255, 255, 255, 0);
            color: rgba(0, 0, 0, 0.2);
          }
          // &:hover {
          //   color: 000;
          //   background-color: #68a4ff;
          // }
          // &.select {
          //   color: 000;
          //   background-color: #68a4ff;
          // }
        }
        &:last-child {
          margin-bottom: 0px;
        }
      }
      .li1 {
        .div {
          font-size: 1.8rem;
          font-family: Calibri;
          font-weight: normal;
          color: #3a636f;
          // &:hover {
          //   // color:000;
          //   background-color: #fff;
          // }
        }
      }
    }
    
  }
}
// .calendar_main.themeType_1{
//   background: rgba(250,  237, 218, 0.85);
    
//   .calendar_right {
//     background: rgba(250,  237, 218, 0.8);
//     border-left: 0.09rem solid #682411;
//     .p {
//       color: #682411;
//       &:hover{
//         color: rgba(58,99,11,0.8);
        
//       }
//     }
//     .flex_box .button {
//       background: #f44336;
//       border: 0.09rem solid #f44336;
//       color: #ffffff;
//     }
//   }
//   .calendar_top {
//     .span1 {
//       color: #682411;
//     }
//     .btn_box {
//       .btn1,.btn2,.btn3,.btn4 {
//         background: rgba(242,205,155,0.5);
//         border: 0.09rem solid #682411;
//         color: #682411;
//       }
//     }
//   }
//   .calendar_cont {
//     .li {
//       background: rgba(242,205,155,0.5);
//       .i_box {
//         .i {
//           background: #682411;
//         }
//       }
//       &:nth-child(1) {
//         background: rgba(244, 251, 253, 0);
//         .div {
//           border-bottom: 0.09rem solid #682411 !important;
//           border-top: 0.18rem solid #682411 !important;
//         }
//       }
//       .div {
//         color: #682411;
//         width: 100%;
//         border-bottom: 0.09rem solid #682411;
//         border-right: 0.09rem solid #682411;
//         &:nth-child(7n + 1) {
//           border-left: 0.09rem solid #682411;
//         }
//         &.noOne {
//           color: rgba(0, 0, 0, 0.2);
//         }
//       }
//     }
//     .li1 {
//       .div {
//         font-size: 1.64rem;
//         font-family: Calibri;
//         font-weight: normal;
//         color: #682411;
//       }
//     }
//   }
//   .scrollbar_style::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
//       border-radius: 0.5rem;
//       // background: #DAE6E0;
//       background: #682411;
//   }
//   .scrollbar_style::-webkit-scrollbar-track {/*滚动条里面轨道*/
//       background: #faedda;
//   }
// }
</style>